import { Model } from ".";

export default class ImageType extends Model {
	get singularNoun() {
		return "image type";
	}
}
